var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "contact-page" }, [
      _c("h1", { staticClass: "page-title" }, [_vm._v("Contact us")]),
      _vm._v(" "),
      _c("p", { staticClass: "support-description" }, [
        _vm._v("\n        Use the chat bubble "),
        _c("img", {
          attrs: { src: "/assets/app/signup/icon-chat-bubble.svg" },
        }),
        _vm._v(" below to be connected to our support team."),
        _c("br"),
        _vm._v(
          "\n        We do our best to answer all questions within 24 hours.\n    "
        ),
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "trouble-description" }, [
        _vm._v("Still having trouble? Reach out to us directly at "),
        _c(
          "a",
          {
            attrs: {
              href: "mailto:support@readtheory.org?subject=Contact%20our%20support",
            },
          },
          [_vm._v("support@readtheory.org")]
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }